import { useMutation, useQueryClient } from "@tanstack/react-query";
import { transactionStatusKeys } from "Api/Queries/Transactions/useTransactionStatus";
import { transactionsDetailKeys } from "Api/Queries/Transactions/useTransactionsDetail";
import { postTransactionsPublicIDBankReturn } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

/**
 * Relays the query string a bank appended to the landing URL after the sign step. Banks that redirect straight
 * to the app (CSAS, ČSOB, FIO, Moneta) put the outcome only there — e.g. Moneta's
 * `response_code=ERROR&error_description=Rejected+by+client` — and the backend would otherwise never see it.
 */
export const useRecordBankReturn = (publicID: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((queryString: string) =>
      postTransactionsPublicIDBankReturn({ queryString }, publicID),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: transactionStatusKeys.byPublicId(publicID),
      });
      queryClient.invalidateQueries({
        queryKey: transactionsDetailKeys.byPublicId(publicID),
      });
    },
    // No onError on purpose: a failed relay must not disturb the detail page — polling still resolves the payment.
  });
};
